import { HttpEmpBiog, HttpCase, HttpH1BForms } from "../Http";

export class I130CasesAPI {

  public static biographicsCreate(input: any) {

    var url = "i130alienrelative/createI130Questionairre";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static biographicsUpdate(input: any) {

    var url = "i130alienrelative/updateI130Questionnarie";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getBiographicsDetails(input: any) {

    var url = "i130alienrelative/getI130QuestionairreByCaseIdAndQuestionerType/" + input.input.caseId + "/" + input.input.questionerType;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpEmpBiog.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }



  public static i130formsCreate(input: any) {

    // var url = "i130alienrelative/createI130Questionairre";

    var url = "/i130forms/create";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i130formsUpdate(input: any) {

    var url = "/i130forms/update";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getI130formsDetails(input: any) {


    var url = "/i130forms/getI130FormsDetailsByCaseId/" + input.input.caseId;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpH1BForms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }

  public static i130FormPdfData(input: any) {
    var url = "caseflow/submitI130PdfGeneration/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios().post(url, input,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        /*   var filename = res.data.outputPdfFilename;
           filename = filename.substring(filename.lastIndexOf('/') + 1);
           var obj = {
               "companyCode": res.data.companyCode,
               "caseId": res.data.caseId
           };
           var urlName = 'fileupload/getFile/' + filename;
            
           HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
           ).then(response => response.data)
               .then(blob => {
     
                   var url = window.URL.createObjectURL(blob);
                   var a = document.createElement('a');
                   a.href = url;
                   a.download = filename;
                   a.click();
                   a.remove();
                   
               }) */
        return res;
      }).catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }


  public static i130AformsCreate(input: any) {

    // var url = "i130Aalienrelative/createI130AQuestionairre";

    var url = "/i130Aforms/create";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i130AformsUpdate(input: any) {

    var url = "/i130Aforms/update";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH1BForms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getI130AformsDetails(input: any) {


    var url = "i130Aforms/getI130AFormDetailsByCaseIdAndQuestionType/" + input.input.caseId + "/" + input.input.questionType;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpH1BForms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }

  public static i130AFormPdfData(input: any) {
    var url = "caseflow/submitI130APdfGeneration/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios().post(url, input,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        return res;
      }).catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }

  public static i131formsCreate(input: any) {

    var url = "i131formQuestionairre/createI131Questionairre";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i131formsUpdate(input: any) {

    var url = "i131formQuestionairre/updateI131Questionnarie";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getI131formsDetails(input: any) {


    var url = "i131formQuestionairre/getI131QuestionairreByCaseIdAndQuestionType/" + input.input.caseId + "/" + input.input.questionType;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpEmpBiog.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }


  public static i131FormPdfData(input: any) {
    var url = "caseflow/submitI131PdfGeneration/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios().post(url, input,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        /*   var filename = res.data.outputPdfFilename;
           filename = filename.substring(filename.lastIndexOf('/') + 1);
           var obj = {
               "companyCode": res.data.companyCode,
               "caseId": res.data.caseId
           };
           var urlName = 'fileupload/getFile/' + filename;
            
           HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
           ).then(response => response.data)
               .then(blob => {
     
                   var url = window.URL.createObjectURL(blob);
                   var a = document.createElement('a');
                   a.href = url;
                   a.download = filename;
                   a.click();
                   a.remove();
                   
               }) */
        return res;
      }).catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }

  public static i864formsCreate(input: any) {

    var url = "/i864formDetails/createI864FormDetails";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i864formsUpdate(input: any) {

    var url = "/i864formDetails/updateI864FormDetails";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getI864formsDetails(input: any) {


    var url = "i864formDetails/getI864FormDetailsByCaseIdAndQuestionType/" + input.input.caseId + "/" + input.input.questionType;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpEmpBiog.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }


  public static i864FormPdfData(input: any) {
    var url = "caseflow/submitI864PdfGeneration/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios().post(url, input,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        /*   var filename = res.data.outputPdfFilename;
           filename = filename.substring(filename.lastIndexOf('/') + 1);
           var obj = {
               "companyCode": res.data.companyCode,
               "caseId": res.data.caseId
           };
           var urlName = 'fileupload/getFile/' + filename;
            
           HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
           ).then(response => response.data)
               .then(blob => {
     
                   var url = window.URL.createObjectURL(blob);
                   var a = document.createElement('a');
                   a.href = url;
                   a.download = filename;
                   a.click();
                   a.remove();
                   
               }) */
        return res;
      }).catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }

  public static i485formsCreate(input: any) {

    var url = "i485formDetails/createI485FormDetails";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static i485formsUpdate(input: any) {

    var url = "i485formDetails/updateI485FormDetails";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpEmpBiog.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }


  public static getI485formsDetails(input: any) {


    var url = "i485formDetails/getI485FormDetailsByCaseIdAndQuestionType/" + input.input.caseId + "/" + input.input.questionType;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpEmpBiog.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }


  public static i485FormPdfData(input: any) {
    var url = "caseflow/submitI485PdfGeneration/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios().post(url, input,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        /*   var filename = res.data.outputPdfFilename;
           filename = filename.substring(filename.lastIndexOf('/') + 1);
           var obj = {
               "companyCode": res.data.companyCode,
               "caseId": res.data.caseId
           };
           var urlName = 'fileupload/getFile/' + filename;
            
           HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
           ).then(response => response.data)
               .then(blob => {
     
                   var url = window.URL.createObjectURL(blob);
                   var a = document.createElement('a');
                   a.href = url;
                   a.download = filename;
                   a.click();
                   a.remove();
                   
               }) */
        return res;
      }).catch((e: any) => {

        return e.response;
      });

    return resultMethod;
  }
}
